import { makeStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: COLORS.WHITE,
    color: COLORS.FONT,
    boxShadow: '0 1px 0 #E5E5E5',
  },
  logout: {
    marginLeft: 'auto',
    fontWeight: 500,
    color: 'inherit',
  },
  logo: {
    maxHeight: 50,
    maxWidth: 200
  }
}))

export { useStyles }
